<template lang="pug">
.dropdown(:class="{'is-active': activeDropdown}" v-on-away="away")
  .dropdown-trigger
    button.button(@click="activeDropdown=!activeDropdown" :disabled="disabled")
      span {{ selected.name }}
  .dropdown-menu(role="menu")
    .dropdown-content
      a.dropdown-item(v-for="item in items" @click="select(item)") {{ item.name }}
</template>
<script>
import { directive as onAway } from 'vue-clickaway'
import { gettext } from '@/services/TranslateHandler'
const _ = require('lodash')
export default {
  name: 'Dropdown',
  directives: {
    onAway
  },
  data () {
    return {
      activeDropdown: false,
      selected: {}
    }
  },
  props: {
    items: {
      default: () => {
        return []
      }
    },
    value: {
      default: () => {
        return {}
      }
    },
    all: {
      default: () => []
    },
    option: {
      default: ''
    },
    disabled: {
      default: false
    }
  },
  methods: {
    gettext: gettext,
    away () {
      this.activeDropdown = false
    },
    select (item) {
      this.activeDropdown = false
      if (item) {
        this.selected = item
        this.$emit('default', false)
        this.$emit('input', item)
      }
    }
  },
  watch: {
    disabled: function (val) {
      if (!val && this.value !== -1) {
        this.select(_.minBy(this.items, 'n'))
      }
    },
    items: function (val) {
      if (val.length) {
        if (this.value) {
          this.select(_.find(this.items, {'id': parseInt(this.value)}))
        }
      }
    },
    value: function (val) {
      if (val === -1) this.select(_.minBy(this.items, 'id'))
      else this.select(_.find(this.items, {'id': val.id}))
    }
  },
  created () {
    if (this.items.length) {
      if (Object.keys(this.value).length) {
        if (this.all.length) this.select(_.find(this.all, {'id': this.value.id}))
        else this.select(_.find(this.items, {'id': this.value.id}))
      } else {
        if (this.option) {
          this.select({id: 0, name: this.option, default: true})
          this.$emit('default', true)
        } else {
          if (_.find(this.items, 'n')) {
            this.select(_.minBy(this.items, 'n'))
          } else {
            this.select(_.minBy(this.items, 'id'))
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/search/components/language-filters/parts/dropdown/index.vue